import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import TrainingContent from "../components/Training/TrainingContent";
import PricingPlansSection from "../components/Training/PricingPlansSection";
import TrainingBanner from "../components/Training/TrainingBanner";

export default function Training() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Entrena mejor | NovaXFit</title>
        <meta
          name="description"
          content="Entrena mejor con NovaXFit. Aprende técnicas de entrenamiento mediante videos prácticos sobre fuerza, máquinas, crossfit y ejercicios funcionales."
        />
        <link rel="canonical" href="https://novaxfit.com/entrenamiento" />
      </Helmet>

      <TrainingContent />
      <TrainingBanner />
      <PricingPlansSection />
    </>
  );
}